import request from 'services/http/request';

export const fetcher = <T, K extends keyof T>(url: string): Promise<K> =>
  request.get(url).then((res) => res.data);
